import config from '../../../../app/global/env.config';
import { routerHelperFactory } from '../../../global/common/services/route-helper-factory';
export const addSubdomain = (url, subdomain) => {
    const subdomainDivider = routerHelperFactory.getSubdomainDivider();
    return [
        url.replace('//', `//${subdomain ? subdomain + subdomainDivider : ''}`),
        '/',
    ].join('');
};
export const getRoomUrl = (room, skipProtocol = false) => {
    const { baseUrl } = config;
    const domain = room.institution ? room.institution.domain : '';
    let url = [addSubdomain(baseUrl, domain), room.slug].join('');
    // @ts-ignore
    const params = new URLSearchParams(window.location.search);
    const query = new URLSearchParams();
    if (params.has('vcp')) {
        query.set('vcp', params.get('vcp'));
    }
    // @ts-ignore
    if (query.toString()) {
        // @ts-ignore
        url += `?${query.toString()}`;
    }
    return skipProtocol ? url.replace(/https*:\/\//, '') : url;
};
